export default __webpack_public_path__ + "static/5-c5256392873fc889bab65b73f0c1d6cc.png";